const getLocationSearch = async (search) => {
  const API_URL = `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${search}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

  const response = await fetch(API_URL, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  }).then((response) => response.json());

  return response;
};

export default getLocationSearch;
